export default __webpack_public_path__ + "fa7fee8a1592bb9e4db6f321eeed2dc8.svg";